const preTitle = {
  fontFamily: 'AkkuratProArabic, sans-serif',
  fontSizeSmall: '14px',
  fontSizeMedium: '14px',
  lineHeightSmall: '17.5px',
  lineHeightMedium: '17.5px',
  fontWeight: '400',
}

const title = {
  fontFamily: 'SackersGothicStd, sans-serif',
  fontSizeSmall: '30px',
  fontSizeMedium: '50px',
  lineHeightSmall: '40px',
  lineHeightMedium: '60px',
  widthSmall: '297px',
  widthMedium: '495px',
  fontWeight: '850',
}

const textStyles = {
  name: '7',
  type: 'Paragraph',
  lineHeight: '15px',
  lineHeightDesktop: '17.5px'
}

const loyaltyHero = {
  preTitle,
  title,
  textStyles
}

export default loyaltyHero